import { useQuery } from "@tanstack/react-query"
import { CaseListItem, CaseListSchema } from "@/types"
import { auth } from "../lib/firebase"

const fetchCases = async (): Promise<CaseListItem[]> => {
	const user = auth.currentUser
	if (!user) {
		throw new Error("User not found.")
	}
	const token = await user.getIdToken()

	const response = await fetch(`${import.meta.env.VITE_API_URL}/api/cases/`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`)
	}
	const rawData = await response.json()

	const parsedData = CaseListSchema.array().parse(rawData)
	return parsedData
}

export const useCases = () => {
	return useQuery<CaseListItem[], Error>({
		queryKey: ["cases"],
		queryFn: fetchCases,
	})
}
